module.exports = "data:application/vnd.ms-fontobject;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmb250cy9pY29tb29uLTU0MGVmOC5lb3QiOw=="


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/icomoon.eot
// module id = 813
// module chunks = 2